












































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import Datepicker from 'vuejs-datepicker'
import DateClass from '@/app/module/date'
import { ja } from 'vuejs-datepicker/dist/locale'

@Component({
  components: {
    Datepicker
  }
})
export default class CamImageSearch extends Vue {
  private recordDate: any = this.$store.state.camImageState.recordDate
  /* datepicker */
  private japanese: any = ja
  private form: any = 'yyyy-MM-dd'

  @Prop() private showModal!: boolean

  @Watch('showModal')
  chengeDisplay () {
    this.recordDate = this.$store.state.camImageState.recordDate
  }

  @Watch('$store.state.camImageState.recordDate')
  getChangeRecordDate () {
    this.recordDate = this.$store.state.camImageState.recordDate
  }

  @Watch('recordDate')
  getChange () {
    this.$emit('change-img', this.recordDate)
  }

  private nextDate () {
    let newDate = new Date(new Date(this.recordDate).getTime() + 1 * 24 * 60 * 60 * 1000)
    this.recordDate = newDate
  }

  private prevDate () {
    let newDate = new Date(new Date(this.recordDate).getTime() - 1 * 24 * 60 * 60 * 1000)
    this.recordDate = newDate
  }
}
